




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';
import * as firebase from 'firebase';
import utility from '@/utility/utility';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class NewTransactionCode extends Vue {
    private newItem: any = {
        orderTransactionCode: '',
        productName: ''
    };

    private onAddTranCode() {
        this.$emit('eventAddTranCode', this.newItem);
        this.newItem = {
            orderTransactionCode: '',
            productName: ''
        };
    }
}
